export const ErrorPage = () => {
  return (
    <div>
      {" "}
      <h1>Oops, algo salió mal 😢</h1>
      <p>La página que buscas no se puede cargar. Intenta nuevamente.</p>
    </div>
  );
};
